import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { UserAuthService } from './auth.service';

export const authGuard: CanActivateFn = () => {
    const auth = inject(UserAuthService);
    const router = inject(Router);
    if (!auth.isLoggedIn()) {
        router.navigateByUrl('/validate');
        return false;
    }
    return true;
};

export const canMatchGuard: CanMatchFn = () => {
    const auth = inject(UserAuthService);
    return auth.isLoggedIn();
};
